import { render, staticRenderFns } from "./addNew.vue?vue&type=template&id=0e1398f3&scoped=true&"
import script from "./addNew.vue?vue&type=script&lang=js&"
export * from "./addNew.vue?vue&type=script&lang=js&"
import style0 from "./addNew.vue?vue&type=style&index=0&id=0e1398f3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1398f3",
  null
  
)

export default component.exports